import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import _ from 'lodash';

class TextEditor extends React.Component {
    constructor() {
        super();
        this.onTextAreaChange = this.onTextAreaChange.bind(this);
    }

    onTextAreaChange() {
        const text = this.textArea.value;
        this.props.setText(text);
    }

    render() {
        const { alignment, italic, bold, font, text, color, placeholder } = this.props;
        const rgb = `rgb(${color.r},${color.g},${color.b})`;
        const style = {
            fontWeight: bold ? 'bold' : 'normal',
            fontStyle: italic ? 'italic' : 'normal',
            textAlign: alignment,
            fontFamily: font,
            color: rgb,
        };
        const customFillCss = `.text-editor__control--color path {fill: ${rgb}};`;
        const baseClass = 'text-editor__control';
        const activeClass = `${baseClass} is-active`;
        const idBrightClass = color.r > 245 && color.g > 245 && color.b > 245 ? 'is-bright' : '';
        return (
            <div className="text-editor">
                <div className="text-editor__controls">
                    <div className="text-editor__control-group styles">
                        <div
                            className={alignment === 'left' ? activeClass : baseClass}
                            onClick={() => this.props.setAlignment('left')}
                        >
                            <Isvg src="/svg/align-left.svg" />
                        </div>
                        <div
                            className={alignment === 'center' ? activeClass : baseClass}
                            onClick={() => this.props.setAlignment('center')}
                        >
                            <Isvg src="/svg/align-center.svg" />
                        </div>
                        <div
                            className={alignment === 'right' ? activeClass : baseClass}
                            onClick={() => this.props.setAlignment('right')}
                        >
                            <Isvg src="/svg/align-right.svg" />
                        </div>
                        {this.props.showColorSelect && (
                            <div
                                className="text-editor__control text-editor__control--color"
                                onClick={() => this.props.openColorPicker()}
                            >
                                <Isvg src="/svg/color-drop.svg" className={idBrightClass} />
                            </div>
                        )}
                        <div
                            className={italic ? activeClass : baseClass}
                            onClick={() => this.props.toggleItalic()}
                        >
                            <Isvg src="/svg/italic.svg" />
                        </div>
                        <div
                            className={bold ? activeClass : baseClass}
                            onClick={() => this.props.toggleBold()}
                        >
                            <Isvg src="/svg/bold.svg" />
                        </div>
                    </div>
                    <div className="text-editor__control-group fonts">
                        <div
                            className={font === 'Arial' ? activeClass : baseClass}
                            onClick={() => this.props.setFont('Arial')}
                        >
                            <span className="text" style={{ fontFamily: 'Arial' }}>
                                Arial
                            </span>
                        </div>
                        <div
                            className={font === 'Times New Roman' ? activeClass : baseClass}
                            onClick={() => this.props.setFont('Times New Roman')}
                        >
                            <div className="text" style={{ fontFamily: 'Times New Roman' }}>
                                Times New Roman
                            </div>
                        </div>
                    </div>
                </div>
                <textarea
                    name="text"
                    className={`text-editor__textarea ${idBrightClass}`}
                    ref={input => {
                        this.textArea = input;
                    }}
                    value={text}
                    style={style}
                    placeholder={placeholder}
                    onChange={this.onTextAreaChange}
                />
                <style>{customFillCss}</style>
            </div>
        );
    }
}

TextEditor.propTypes = {
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    showColorSelect: PropTypes.bool,
};

TextEditor.defaultProps = {
    onChange: () => {},
    placeholder: '',
    showColorSelect: true,
};

export default TextEditor;
